import { scrollToEl, headerOffsetHeight } from './helpers';

// See the inline script in header.php: the hash is stripped from the URL
// before the browser can natively (and offset-blind) jump to it, and stashed
// here so we can scroll to it ourselves once the page is ready.
const hash = window.emInitialHash;
if (hash) {
	scrollToEl(document.querySelector(hash), headerOffsetHeight());

	// Restore the hash in the URL without adding a new history entry.
	if (window.history.replaceState) {
		window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${hash}`);
	}
}
